import { render, staticRenderFns } from "./free-login.vue?vue&type=template&id=cf4b49b8&scoped=true&"
import script from "./free-login.vue?vue&type=script&lang=js&"
export * from "./free-login.vue?vue&type=script&lang=js&"
import style0 from "./free-login.vue?vue&type=style&index=0&id=cf4b49b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4b49b8",
  null
  
)

export default component.exports